import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { DeviceTypes, PhoneTypes } from 'generated/graphql-types';
import { AddHardphoneViewComponent } from '../../add-phone-to-device/views/add-hardphone-view.component';
import { DeviceDetailView } from '../models/device-detail-view.model';
import { PhoneDetailSaveModel } from '../models/phone-detail-save.model';
import { PhoneDetailView } from '../models/phone-detail-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-phone-view',
    styleUrls: ['./add-phone-view.component.scss'],
    templateUrl: './add-phone-view.component.html',
    standalone: false
})
export class AddPhoneViewComponent {
   @ViewChild('addHardphoneView', { static: false })
   addHardphoneView: AddHardphoneViewComponent;

   @Output() formSubmitted = new EventEmitter<PhoneDetailSaveModel>();

   @Output() formCanceled = new EventEmitter<void>();

   @Output() device: DeviceDetailView;

   @Input() form: UntypedFormGroup;

   @Input() accountId: number;

   @Input() callState: CallState;

   @Input() phone: PhoneDetailView;

   @Input() phoneTypes: typeof PhoneTypes = PhoneTypes;

   @Input() isSystemUser: boolean;

   DeviceTypes = DeviceTypes;

   columns: string[] = ['internalip', 'externalip', 'useragent'];

   get sipUserArray(): UntypedFormArray {
      return this.form.get('sipUserArray') as UntypedFormArray;
   }

   get hardphoneArray(): UntypedFormArray {
      return this.form.get('hardphoneArray') as UntypedFormArray;
   }

   get handsetArray(): UntypedFormArray {
      return this.form.get('handsetArray') as UntypedFormArray;
   }

   showPassword = false;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
